/*
 * @Description:
 * @Author: ShuaiBi
 * @Date: 2021-05-28 10:06:24
 * @LastEditTime: 2022-06-09 11:52:56
 * @LastEditors:
 */
import React, { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Loading from '@/components/loading'

const Home = lazy(() => import('./home'))
const ShengXiaoXin = lazy(() => import('@/pages/shengxiaoxin'))
export default function Routers() {
  return (
    <Router basename={__DEV__ ? '/' : '/'}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/shengxiaoxin" exact component={ShengXiaoXin} />
        </Switch>
      </Suspense>
    </Router>
  )
}
